import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_BANKBRANCH,
  DELETE_BANKBRANCH,
  UPDATE_BANKBRANCH,
  ADD_NEW_BANKBRANCH,
} from "./actionType";

import {
  getBankBranchSuccess,
  getBankBranchFail,
  deleteBankBranchSuccess,
  deleteBankBranchFail,
  updateBankBranchSuccess,
  updateBankBranchFail,
  addBankBranchSuccess,
  addBankBranchFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getBankBranchApi,
  updateBankBranchApi,
  deleteBankBranchApi,
  addNewBankBranchApi
} from "../../helpers/backend_helper";

function* getBankBranch({ payload: bankBranch }) {
  try {
    const response = yield call(getBankBranchApi, bankBranch);
    yield put(getBankBranchSuccess(GET_BANKBRANCH, response.data));
  } catch (error) {
    yield put(getBankBranchFail(GET_BANKBRANCH, error));
  }
}

function* onUpdateBankBranch({ payload: bankBranch }) {
  try {
    const response = yield call(updateBankBranchApi, bankBranch);
    yield put(updateBankBranchSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateBankBranchFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteBankBranch({ payload: bankBranch }) {
  try {
    const response = yield call(deleteBankBranchApi, bankBranch);
    yield put(deleteBankBranchSuccess({ bankBranch, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteBankBranchFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewBankBranch({ payload: bankBranch }) {
  try {
    const response = yield call(addNewBankBranchApi, bankBranch);
    yield put(addBankBranchSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addBankBranchFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetBankBranch() {
  yield takeEvery(GET_BANKBRANCH, getBankBranch);
}

export function* watchUpdateBankBranch() {
  yield takeEvery(UPDATE_BANKBRANCH, onUpdateBankBranch);
}

export function* watchDeleteBankBranch() {
  yield takeEvery(DELETE_BANKBRANCH, onDeleteBankBranch);
}

export function* watchAddNewBankBranch() {
  yield takeEvery(ADD_NEW_BANKBRANCH, onAddNewBankBranch);
}

function* bankBranchSaga() {
  yield all([
    fork(watchGetBankBranch),
    fork(watchDeleteBankBranch),
    fork(watchUpdateBankBranch),
    fork(watchAddNewBankBranch)
  ]);
}

export default bankBranchSaga;
